export const ROLES_WITH_ADMIN_PRIVILEGES = ['Super Admin', 'Acquisitions Lead'];

export const ROLES_FOR_CONTENTSQUARE_TRACKING = ['Acquisitions Lead', 'Acquisitions Team'];

export const BLOCK_AUTHOR_ALLOWED_ROLES = ['Acquisitions Lead'];

export const CONTENTSQUARE_SCRIPTS = {
  dev: 'https://t.contentsquare.net/uxa/4acc84e715ba1.js',
  prod: 'https://t.contentsquare.net/uxa/417ddc11e0c31.js'
};

export const ACTIONS_GENRE = {
  delete: 'delete',
  create: 'create',
  edit: 'edit'
};

export const DAILY_RANK_EXPORT_ROWS = 10000;

export const BOXED_SET_CDN_URL = 'https://cdn-icons-png.flaticon.com/512/29/29302.png';

export const feedbackOptions: string[] = [
  'Login/Logout',
  'User Management',
  'Dashboard',
  'Specific Bookstat Tab',
  'Specific Royal Road Tab',
  'Specific Daily Rank Tab',
  'Moving Titles To HubSpot'
];

export const OverlayBookstatDataList = [
  'Current Tab',
  'Date Pub',
  'Added',
  'Days Tracked',
  'ASIN',
  'Genre',
  'Podium Hit Count',
  'Num. of Pages',
  'Projected Sales',
  'Average Projected Sales',
  'Max Projected Sales',
  'Amzn Rating',
  'Amzn Reviews',
  'eBooks Sold'
];

export const OverlayRoyalRoadDataList = [
  'Current Tab',
  'First Published Date',
  'Fiction Id',
  'Added',
  'Patreon',
  'Genre',
  'Pages',
  'Followers',
  'Ratings',
  'Average Views',
  'Views',
  'Type',
  'Status',
  'Overall Score'
];

export const OverlayAO3DataList = [
  'Current Tab',
  'First Published Date',
  'Link',
  'Fandom',
  'Hits',
  'Added',
  'Words',
  'Kudos',
  'Bookmarks',
  'Comments',
  'Last Updated Date'
];

export const BrowserNames = {
  Chrome: 'Google Chrome',
  Safari: 'Safari',
  Firefox: 'Mozilla Firefox',
  Edge: 'Microsoft Edge',
  Opera: 'Opera',
  Vivaldi: 'Vivaldi',
  Brave: 'Brave'
};

export const AVATAR_COLORS = ['#5b89c2', '#c95c57', '#8108b3', '#008028', '#1dc6cc'];

export const UserEventsList = ['click', 'scroll', 'mousemove', 'keypress'];
export const USER_ACTIVITY_EXPIRY_EXTENSION_MS = 120000;
export const USER_ACTIVITY_CHECK_INTERVAL_MS = 60000;

export const TABLEAU_EMBED_SCRIPT_SRC =
  'https://us-west-2b.online.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js';

// Fallback -- live value comes from GET /config.
export const TABLEAU_AUTHOR_PERFORMANCE_VIEW_URL =
  // eslint-disable-next-line max-len
  'https://us-west-2b.online.tableau.com/t/podiumpublishing/views/TitleProfitabilityReport/BrendaTitlePerformance';

// Browser form of the embed URL. Fallback -- normally derived from /config.
export const TABLEAU_AUTHOR_DETAILS_LINK_URL =
  // eslint-disable-next-line max-len
  'https://us-west-2b.online.tableau.com/#/site/podiumpublishing/views/TitleProfitabilityReport/BrendaTitlePerformance';

export const HUBSPOT_PORTAL_IDS = {
  dev: '51090615',
  prod: '19914558'
};

// HubSpot Contact object type ID is 0-1
export const hubspotAuthorContactPageUrl =
  'https://app.hubspot.com/contacts/{portalId}/record/0-1/{contactId}';